import React from 'react';
import LineChart from "../../common/charts/LineChart";
import ChartLegend from "../../common/charts/ChartLegend";
import GroupChartDataSelect from "./filters/GroupChartDataSelect";
import DoughnutChart from "../../common/charts/DoughnutChart";
import Collapse from "reactstrap/es/Collapse";
import {useSelector} from "react-redux";
import useResizeObserver from "../../../hooks/useResizeObserver";
import {isMobileHorizontalScreen} from "../../../utils/displayUtils";

export default function StatisticChart({chartData, pageState, toggleColumnsLineChartLegend, toggleGroupChartLegend, selectGroupChartDataType }) {
    const scrollableEl = document.getElementById("scrollable");
    const scrollableObserver = useResizeObserver( scrollableEl);

    const hasChartData = chartData?.labels?.length;
    const isLoggedAsPartner = useSelector(state => state.auth.isPartner || state.auth.isAdminAsPartner);

    const {showColumnsLineChart, showGroupDonutChart, showGroupLineChart, displayedLines, displayedGroupChartLines, selectedTab, groupChartSelectedDataType, filters} = pageState;
    const {chartBtnSelected} = filters;
    const legendEl = document.getElementById("chart_legend");
    const legendObserver = useResizeObserver( legendEl);
    const legendRowEl = document.getElementById("legend");
    const legendRowRect = legendRowEl?.getBoundingClientRect();

    const isFullWidthChart = showGroupDonutChart ? (scrollableObserver?.width <= 730) : (scrollableObserver?.width <= 1140);


    const chartHeight = isMobileHorizontalScreen() ? 250 : 320;

    const chartStyle = {
        paddingTop: '10px',
        width: isFullWidthChart ? "100%" : showGroupDonutChart ? "300px" : "65%",
        maxHeight: (chartHeight - 20) + 'px',
        height: (chartHeight - 20) + 'px',
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }
    const legendStyle = {
        paddingLeft: isFullWidthChart ? "20px" : "45px",
        width: isFullWidthChart ? "100%" : null,
    };

    const collapseStyle = {
        display: showGroupDonutChart ? "flex" : null,
        justifyContent: showGroupDonutChart ? "center" : null
    }

    return <div id="stat_chart" >
        <Collapse isOpen={chartBtnSelected}>
            <div style={collapseStyle}>
        {
            showColumnsLineChart &&
            <>
                {
                    hasChartData
                        ?
                        <div className="row" style={{display: "flex", justifyContent: "center"}}>
                            <div id='chart' style={chartStyle}>
                                <LineChart {...chartData} displayedLines={displayedLines} height={chartHeight} isLoggedAsPartner={isLoggedAsPartner}/>
                            </div>
                            <div id='chart_legend'  style={legendStyle}>
                                <ChartLegend type="line"
                                             lines={chartData && chartData.chartData ? chartData.chartData.map(data => data.lineName) : []}
                                             displayedLines={displayedLines}
                                             toggleChartLegend={toggleColumnsLineChartLegend}
                                             isFullWidthChart={isFullWidthChart}
                                />
                            </div>
                        </div>
                        : <div/>
                }
            </>
        }
        {
            showGroupLineChart &&
            <>
                {
                    hasChartData
                        ?
                        <div className="row" style={{display: "flex", justifyContent: "center"}}>
                            {<div id='chart' style={chartStyle}>
                                <LineChart {...chartData} displayedLines={displayedGroupChartLines} height={chartHeight}
                                           isLoggedAsPartner={isLoggedAsPartner} showGroupLineChart={showGroupLineChart}
                                           isFullWidthChart={isFullWidthChart}/>
                            </div>}
                            <div id='chart_legend'  style={legendStyle}>
                                <GroupChartDataSelect value={groupChartSelectedDataType}
                                                      onSelect={selectGroupChartDataType}
                                                      statisticType={selectedTab}
                                                      width={legendRowRect?.width}
                                />
                                <ChartLegend type="doughnut" lines={chartData && chartData.chartData ? chartData.chartData.map(data => data.lineName) : []}
                                             displayedLines={displayedGroupChartLines}
                                             toggleChartLegend={toggleGroupChartLegend}
                                             isFullWidthChart={isFullWidthChart}/>
                            </div>

                        </div>
                        :
                        <div/>
                }
            </>
        }
        {
            showGroupDonutChart &&
            <>
                {
                    hasChartData
                        ?
                        <div className="row" style={{display: "flex", justifyContent: "flex-start"}}>
                            <div id='chart' style={chartStyle}>
                                {chartData && <DoughnutChart{...chartData} dataType={groupChartSelectedDataType.label} height={chartHeight} />}
                            </div>
                            <div id='chart_legend' style={legendStyle}>
                                <GroupChartDataSelect value={groupChartSelectedDataType}
                                                      onSelect={selectGroupChartDataType}
                                                      statisticType={selectedTab}
                                                      donutChart={showGroupDonutChart}
                                                      width={legendRowRect?.width}/>
                                <ChartLegend type="doughnut" lines={chartData.allLabels}
                                             displayedLines={displayedGroupChartLines}
                                             toggleChartLegend={toggleGroupChartLegend}
                                             isFullWidthChart={isFullWidthChart}/>
                            </div>
                        </div>
                        :
                        <div/>
                }
            </>
        }
            </div>
    </Collapse>
    </div>;
};